import React from 'react'
import { IconProps } from '../../types/types'

const MenuIcon: React.FC<IconProps> = ({ color = '#585558', size = '23', className }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M2.875 6.70833H20.125" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M2.875 11.5H20.125" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M2.875 16.2917H20.125" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

export default MenuIcon